import React, { useState } from 'react';
import { SiInstagram, SiX, SiTiktok, SiWhatsapp, SiLinkedin, SiFacebook, SiReddit } from 'react-icons/si';
import './App.css';
import Profile from './Profile';
import About from './About';
import Directory from './Directory';

export default function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [isMember, setIsMember] = useState(() => {
    try { return localStorage.getItem('mdoukha_member') === 'true'; } catch { return false; }
  });

  const handleMemberLogin = () => {
    setIsMember(true);
    try { localStorage.setItem('mdoukha_member', 'true'); } catch {}
  };

  const handleMemberLogout = () => {
    setIsMember(false);
    try { localStorage.removeItem('mdoukha_member'); } catch {}
  };

  return (
    <div className="app-root">
      {/* Navigation */}
      <nav className="nav">
        <div className="nav-container">
          <div className="nav-left">
            <img src="/mdoukha_logo_small.png" alt="Mdoukha logo" className="nav-logo" />
            <h1 className="nav-title">Mdoukha Village - A village of proud heritage.</h1>
          </div>
          <div className="nav-buttons">
            <button
              onClick={() => setCurrentPage('home')}
              className={currentPage === 'home' ? 'active' : ''}
            >
              Home
            </button>
            <button
              onClick={() => setCurrentPage('about')}
              className={currentPage === 'about' ? 'active' : ''}
            >
              About
            </button>
            <button
              onClick={() => setCurrentPage('profiles')}
              className={currentPage === 'profiles' ? 'active' : ''}
            >
              Community Profiles
            </button>
            <button
              onClick={() => setCurrentPage('directory')}
              className={currentPage === 'directory' ? 'active' : ''}
            >
              Directory
            </button>

          </div>
        </div>
      </nav>

      {/* Home Page */}
      {currentPage === 'home' && (
        <main className="home">
          <div className="home-inner">
            <div className="hero">
              <div className="w-48 h-48 mx-auto mb-8 bg-white rounded-full flex items-center justify-center shadow-2xl overflow-hidden">
                <img src="/mdoukha_logo.png" alt="Mdoukha Logo" className="w-full h-full object-cover" />
              </div>
            </div>

            {/* Social Media Section */}
            <section className="social-section">
              <p className="social-heading">Follow us on these social media sites</p>
              <div className="social-links">
                <a href="https://www.instagram.com/mdoukhavillage/" className="social-link social-instagram" aria-label="Instagram">
                  <SiInstagram size={20} className="icon-white" />
                </a>
                <a href="https://x.com/mdoukhavillage" className="social-link social-unknown" aria-label="X">
                  <SiX size={20} className="icon-white" />
                </a>
                <a href="https://www.tiktok.com/@mdoukhavillage" className="social-link social-music" aria-label="TikTok">
                  <SiTiktok size={20} className="icon-white" />
                </a>
                <a href="https://whatsapp.com/channel/0029VbBNobqJ93wTDS9xhk13" className="social-link social-chat" aria-label="WhatsApp">
                  <SiWhatsapp size={20} className="icon-white" />
                </a>
                <a href="https://www.reddit.com/r/mdoukha/" className="social-link social-reddit" aria-label="Reddit">
                  <SiReddit size={20} className="icon-white" />
                </a>
                {/* <a href="https://www.linkedin.com/company/mdoukhavillage" className="social-link social-linkedin" aria-label="LinkedIn">
                  <SiLinkedin size={20} className="icon-white" />
                </a>
                <a href="https://www.facebook.com/mdoukhavillage" className="social-link social-facebook" aria-label="Facebook">
                  <SiFacebook size={20} className="icon-white" />
                </a> */}
              </div>
            </section>
          </div>
        </main>
      )}

      {/* Profiles Page (moved to separate component) */}
      {currentPage === 'profiles' && <Profile />}

      {/* Directory (member-only) */}
      {currentPage === 'directory' && (
        <Directory isMember={isMember} onLogin={handleMemberLogin} onLogout={handleMemberLogout} />
      )}

      {/* About Page */}
      {currentPage === 'about' && <About />}
    </div>
  );
}